import React, { useState, useEffect, useRef } from "react";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";

const SearchPopup = ({ isOpen, onClose }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Define services and additional pages data
  const services = {
    "services": {
      "ifm-services": {
        title: "IFM Services",
        path: "/service/ifm-services",
      },
      "hard-services": {
        title: "Hard Services",
        path: "/service/hard-services",
      },
      "soft-services": {
        title: "Soft Services",
        path: "/service/soft-services",
      },
      "security-services": {
        title: "Security Services",
        path: "/service/security-services",
      },
      "specialized-services": {
        title: "Specialized Services",
        path: "/service/specialized-services",
      },
    },
    "hard-services": {
      "chiller": {
        title: "Chiller",
        path: "/service/hard-services/chiller",
      },
      "hvac-systems": {
        title: "HVAC Systems",
        path: "/service/hard-services/hvac-systems",
      },
     "electrical": {
        title: "Electrical",
        path: "/service/hard-services/electrical",
      },
      "plumbing": {
        title: "Plumbing",
        path: "/service/hard-services/plumbing",
      },
      "civil": {
        title: "Civil",
        path: "/service/hard-services/civil",
      },
      "carpentry": {
        title: "Carpentry",
        path: "/service/hard-services/carpentry",
      },
      "painting": {
        title: "Painting",
        path: "/service/hard-services/painting",
      },
    },
    "soft-services": {
      "house-keeping": {
        title: "Housekeeping",
        path: "/service/soft-services/house-keeping",
      },
      "facade-cleaning": {
        title: "Facade Cleaning",
        path: "/service/soft-services/facade-cleaning",
      },
      "pest-control": {
        title: "Pest Control",
        path: "/service/soft-services/pest-control",
      },
    },
    "security-services": {
      security: {
        title: "Security",
        path: "/service/security-services/security",
      },
      "life-guard": {
        title: "Life Guard",
        path: "/service/security-services/life-guard",
      },
      concierge: {
        title: "Concierge",
        path: "/service/security-services/concierge",
      },
    },
    "specialized-services": {
      "elv-systems": {
        title: "ELV Systems",
        path: "/service/specialized-services/elv-systems",
      },
      "fire-fighting": {
        title: "Fire Alarm & Fire Fighting",
        path: "/service/specialized-services/fire-fighting",
      },
      elevator: {
        title: "Elevator",
        path: "/service/specialized-services/elevator",
      },
      landscaping: {
        title: "Landscaping",
        path: "/service/specialized-services/landscaping",
      },
      "waste-management": {
        title: "Waste Management",
        path: "/service/specialized-services/waste-management",
      },
      "bmu-maintenance": {
        title: "BMU Maintenance",
        path: "/service/specialized-services/bmu-maintenance",
      },
    },
    // Additional pages
    "page": {
      "industry": {
        title: "Industry We Serve",
        path: "/industry",
      },
      "services": {
        title: "Services",
        path: "/services",
      },
      "client-portfolio": {
        title: "Client Portfolio",
        path: "/client-portfolio",
      },
      "accreditations": {
        title: "Accreditations",
        path: "/accreditations",
      },
      "contact-us": {
        title: "Contact Us",
        path: "/contact-us",
      },
      "request-quote": {
        title: "Request A Quote",
        path: "/request-quote",
      },
      "faqs": {
        title: "FAQs",
        path: "/faqs",
      },
      "careers": {
        title: "Careers",
        path: "/careers",
      },
      "cookie-policy": {
        title: "Cookie Policy",
        path: "/cookie-policy",
      },
      "who-we-are": {
        title: "Who We Are",
        path: "/who-we-are",
      },
      "mission-vision": {
        title: "Mission & Vision",
        path: "/mission-vision",
      },
      "testimonials": {
        title: "Testimonials",
        path: "/testimonials",
      },
      "health-safety": {
        title: "Health & Safety",
        path: "/health-safety",
      },
      "sustainability": {
        title: "Sustainability",
        path: "/sustainability",
      },
      "smart-tech": {
        title: "Smart Tech",
        path: "/smart-tech",
      },
    },
  };

  useEffect(() => {
    if (searchQuery) {
      const results = [];
      Object.entries(services).forEach(([serviceType, serviceGroup]) => {
        Object.entries(serviceGroup).forEach(([key, service]) => {
          if (service.title.toLowerCase().includes(searchQuery.toLowerCase())) {
            results.push({
              title: service.title,
              path: service.path,
              type: serviceType,
            });
          }
        });
      });
      setSearchResults(results);
    } else {
      setSearchResults([]);
    }
  }, [searchQuery]);

  const handleServiceSelect = (path) => {
    navigate(path);
    setSearchQuery("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="search-results-wrapper">
      <div className="search-box">
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Search services..."
          className="search-input"
          autoFocus
        />
        <button className="search-close" onClick={onClose}>
          <X size={16} />
        </button>
      </div>
      {searchResults.length > 0 && (
        <div className="search-results">
          {searchResults.map((result, index) => (
            <button
              key={index}
              className="result-item"
              onClick={() => handleServiceSelect(result.path)}
            >
              {result.title}
              <span className="result-type">
                {result.type.replace("-", " ")}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchPopup;